/*
 * @Description: 附件
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  上一页: '上一页',
  页: '页',
  下一页: '下一页',
  放大: '放大',
  缩小: '缩小',
  旋转: '旋转',
  原始尺寸: '原始尺寸',
  适应页面: '适应页面',
  预览: '预览',
  删除: '删除',
  无命名文件: '无命名文件',
  '文件已下载完成，可通过浏览器下载文件夹查看': '文件已下载完成，可通过浏览器下载文件夹查看',
  '文件已下载完成，可通过飞书左下角近期下载文件夹查看': '文件已下载完成，可通过飞书左下角近期下载文件夹查看',
  下载失败请重试: '下载失败，请重试！',
  本字段只支持移动端拍照上传: '本字段只支持移动端拍照上传',
  '下载失败，请重试！': '下载失败，请重试！',
  '获取文件失败，请重试！': '获取文件失败，请重试！',
  粘贴或拖拽上传: '粘贴或拖拽上传',
  粘贴或拖拽至这里上传: '粘贴或拖拽至这里上传',
  添加本地文件: '添加本地文件',
  重试: '重试',
  上传附件: '上传附件'
};
